import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import LaundryTaskListTable from './Componate/LaundryTaskListTable'

const LaundryTaskList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Laundry Task List</HeadingOne>
                    <AddItemBtn url="add-laundry-task" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <LaundryTaskListTable />
            </div>
        </PageBody>
    )
}

export default LaundryTaskList
